import React from 'react'
import { useTranslation } from 'react-i18next'
import Label from '../../../elements/formLabel'

const GroupConfigHeading: React.FC = () => {
    const { t } = useTranslation()
    return (
        <div className="grid grid-cols-9 gap-2">
            <div className="col-span-4 grid grid-cols-2 gap-2">
                <Label text={t('Group Name')} className="text-center w-full" />
                <Label text={t('Action Taken')} />
            </div>
            <div className="col-span-2 flex items-center justify-center">
                <Label text={t('Control Group')} />
            </div>

            <div className="col-span-3 grid grid-cols-3 gap-2 items-center">
                <div className="col-span-2 ">
                    <Label text={t('Distribution%')} />
                </div>
                <div className="flex items-center">
                    <Label text={t('Group Size')} />
                </div>
            </div>
        </div>
    )
}

export default GroupConfigHeading
